export default "__VITE_ASSET__DLpY6c3k__"